
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import apiClient from '@/app/clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import { ToastType } from '@/lib/components/toast/types';
import logger from '@/app/logger';
import TInput from '@/lib/form/input/Input.vue';
declare let PARTNER_MODE: boolean;
declare let PARTNER_ID: string;

@Component({
  name: 'set-password',
  components: {
    TButton,
    TInput
  },
  props: ['mode', 'context', 'flowType']
})
export default class VerifyOtp extends Vue {
  private context!: any;
  private genericLoader = false;
  private partnerMode = PARTNER_MODE;
  private partnerId = PARTNER_ID;
  flowType;
  invalidPassword = '';
  invalidConfirmPassword = '';
  password = '';
  confirmPassword = '';
  mode!: string;

  get heading() {
    if (this.mode == 'signup' && this.flowType == 'set_password') {
      return this.$t('onboard.register.email_sign_up.set_password_title');
    } else if (this.flowType == 'reset_password') {
      return this.$t('onboard.register.email_sign_up.reset_password_title');
    } else if (this.flowType == 'set_password') {
      return this.$t('onboard.register.email_sign_up.set_password_title');
    }
  }

  get cta() {
    if (this.mode == 'signup') {
      return this.$t('onboard.register.email_sign_up.set_password_cta_signup');
    }
    if (this.flowType == 'reset_password') {
      return this.$t('onboard.register.email_sign_up.set_password_cta_reset');
    } else if (this.flowType == 'set_password') {
      return this.$t('onboard.register.email_sign_up.set_password_cta_set');
    }
  }

  get description() {
    return this.$t('onboard.register.email_sign_up.passowrd_description');
  }

  get email() {
    return this.context.email;
  }

  validatePassword(password) {
    if (!/[a-z]/.test(password)) {
      return 'Must contain a lowercase character';
    } else if (!/[A-Z]/.test(password)) {
      return 'Must contain a uppercase character';
    } else if (!/[0-9]/.test(password)) {
      return 'Must contain a numeric character';
    } else if (!/[ -/:-@[-`{-~]/.test(password)) {
      return 'Must contain a special character';
    } else if (password.length < 8) {
      return 'Must contain minimum 8 characters';
    }
    return '';
  }

  next() {
    this.invalidPassword = this.validatePassword(this.password);
    if (this.invalidPassword) {
      return;
    }
    this.invalidConfirmPassword =
      this.validatePassword(this.confirmPassword) ||
      this.password != this.confirmPassword
        ? 'Passwords must match'
        : '';
    if (this.invalidConfirmPassword) {
      return;
    }
    this.genericLoader = true;
    apiClient
      .setPassword(this.email, this.password, this.context.authToken)
      .then(data => {
        if (this.context.targetFlow == 'login') {
          this.$success(
            this.$t('onboard.register.email_sign_up.reset_password')
          );
          this.$emit('update', {
            flowType: 'login',
            data: {
              email: this.email
            }
          });
        } else if (this.context.targetFlow == 'profile_setup') {
          this.$emit('update', {
            flowType: 'profile_setup',
            data: {
              targetFlow: 'set_workspace',
              authToken: this.context.authToken
            }
          });
        }
        this.genericLoader = false;
      })
      .catch(e => {
        this.genericLoader = false;
        this.$error(e);
      });
  }
}
